import styled from "styled-components/macro";

export const MainWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  justify-items: end;
  transition: 0.5s;
  @media ${(props) => props.theme.media.leftmenu} {
    margin: 0 auto;
    width: 100%;
  }
`;
